import React from "react";
import "./AboutSection.css";
import aboutImage from "./about.png"; // Replace with your image file

const AboutSection = () => {
  return (
    <section className="about-container">
      <div className="about-header">
        <h2 className="about-title">About Us – Biofana</h2>
        <p className="about-subtitle">
          Harnessing the Power of Nature, One Powder at a Time
        </p>
      </div>

      <div className="about-content">
        <div className="about-image-container">
          <img src={aboutImage} alt="A large field with rows of green plants under a sunset" />
        </div>
        <div className="about-text-container">
          <div className="about-text">
            <p>
              At Biofana, we transform nature’s finest fruits and vegetables into
              clean, nutrient-rich powders — without additives, preservatives, or
              shortcuts. From banana, turmeric, and cocoa to tomato and onion, our
              products are made with care, quality, and sustainability at every
              step.
            </p>
            <p>
              We believe in delivering natural goodness that supports healthier
              living and smarter food choices — whether you're blending a smoothie
              at home or developing health foods at scale.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;